<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="581" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Sửa điểm danh
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="pt-4">
          <v-row>
            <v-col> Ngày {{ getCurrentDate }} </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <CardStudentName :student="selectedAttendance.student" />
            </v-col>
            <v-col cols="6" class="d-flex justify-space-between align-center">
              <div>
                <p class="text-caption my-0">Ngày sinh</p>
                <span>{{ $_get(selectedAttendance, 'student.dob', '') | ddmmyyyy }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Mã số</p>
                <span>{{ $_get(selectedAttendance, 'student.code', '') | getStudentCode }}</span>
              </div>
              <div>
                <p class="text-caption my-0">Lớp</p>
                <span>{{ $_get(selectedAttendance, 'class.title', '') }}</span>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center"> Giờ đến (24h) <span class="error--text">*</span> </v-col>
            <v-col cols="4">
              <TimeInput
                label="Giờ đến (24h)"
                outlined
                dense
                outline
                :date.sync="checkIn"
                :selectedDate="getCurrentDate"
                class="required"
                :rules="[$rules.required, $rules.time]"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4" class="d-flex align-center">Giờ về (24h) </v-col>
            <v-col cols="4">
              <TimeInput
                label="Giờ về (24h)"
                outlined
                dense
                outline
                :selectedDate="getCurrentDate"
                :rules="[$rules.time]"
                :date.sync="checkOut"
              />
            </v-col>
            <!-- <v-col cols="4">
              <v-checkbox class="my-0" label="Đi học muộn" v-model="late"></v-checkbox>
            </v-col> -->
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="#0D47A1" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName'
import moment from 'moment'
import TimeInput from '@/components/basic/TimeInput.vue'

export default {
  components: {
    CardStudentName,
    TimeInput
  },
  data() {
    return {
      dialog: false,
      checkIn: '',
      checkOut: ''
      // late: false
    }
  },
  props: {
    state: Boolean,
    selectedAttendance: Object,
    checkinObject: Object
  },
  computed: {
    ...mapState('attendance', ['date']),

    getCurrentDate() {
      return moment(this.date).format('DD/MM/YYYY')
    },
    checkInTime() {
      return this.checkIn ? moment(this.checkIn).format('HH:mm') : null
    },
    checkOutTime() {
      return this.checkOut ? moment(this.checkOut).format('HH:mm') : null
    }
  },
  methods: {
    ...mapActions('attendance', ['updateAttendance', 'createAttendance', 'createCheckin', 'updateCheckin']),
    checkInChange(data) {
      this.checkIn = moment(data, 'hh:mm').toISOString()
    },
    checkOutChange(data) {
      this.checkOut = moment(data, 'hh:mm').toISOString()
    },
    async save() {
      if (!this.$refs.form.validate()) return
      if (this.checkOut && this.checkIn && moment(this.checkOut).isBefore(moment(this.checkIn))) {
        this.$alert.error('Giờ về phải lớn hơn giờ đến')
        return
      }
      try {
        this.$loading.active = true
        if (!get(this.checkinObject, 'id', '')) {
          const checkInData = {
            status: this.checkOut ? 'left' : 'attendance',
            checkIn: this.checkIn,
            checkOut: this.checkOut || null,
            student: get(this.selectedAttendance, 'student.id', ''),
            attendance: this.selectedAttendance.id
          }
          await this.createCheckin(checkInData)

          const attendanceData = {
            id: this.selectedAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn
          }
          await this.updateAttendance(attendanceData)
        } else {
          if (this.checkinObject.checkOut && !this.checkOut) {
            this.$alert.error('Học sinh đã rời trường, giờ về là bắt buộc')
            return
          }

          await this.updateCheckin({
            id: this.checkinObject.id,
            status: this.checkOut ? 'left' : 'attendance',
            checkIn: this.checkIn,
            checkOut: this.checkOut || null
          })

          await this.updateAttendance({
            id: this.selectedAttendance.id,
            status: this.checkOut ? 'left' : 'attendance',
            time: this.checkOut ? this.checkOut : this.checkIn
          })
        }

        this.$alert.updateSuccess()
        // this.$emit('attendanceUpdated')
      } catch (error) {
        console.error(error)
        this.$alert.updateError()
      } finally {
        this.$loading.active = false
      }

      this.dialog = false
    },
    reset() {
      this.$refs.form.reset()
    },
    cancel() {
      this.dialog = false
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    },
    checkinObject: {
      handler(checkinObject) {
        if (checkinObject && checkinObject.id) {
          this.checkIn = checkinObject.checkIn ? moment(checkinObject.checkIn).toISOString() : ''
          this.checkOut = checkinObject.checkOut ? moment(checkinObject.checkOut).toISOString() : ''
        } else {
          this.checkIn = ''
          this.checkOut = ''
        }
      },
      immediate: true,
      deep: true
    }
  }
}
</script>
